// setupBasePath is a type-relative template such as "/billing/:portalInstanceId?".
// The service intentionally never resolves it to an instance — creation happens
// before an instance exists — so we drop every ":param" segment and leave the
// static prefix the consuming app routes against.
export function resolveSpaceSetupPath(setupBasePath) {
  const resolved = setupBasePath.split('/').filter(segment => !segment.startsWith(':')).join('/');
  if (resolved === '') return '/';
  return resolved.length > 1 ? resolved.replace(/\/$/, '') : resolved;
}
export function buildCreatableSpaces({
  data,
  loading
}) {
  var _data$creatableSpaces;
  const creatableSpaces = ((_data$creatableSpaces = data === null || data === void 0 ? void 0 : data.creatableSpaces) !== null && _data$creatableSpaces !== void 0 ? _data$creatableSpaces : []).map(space => ({
    portalInstanceType: space.portalInstanceType,
    displayName: space.displayName,
    setupPath: resolveSpaceSetupPath(space.setupBasePath),
    locked: space.locked
  }));
  return {
    creatableSpaces,
    loading
  };
}